import router from './router'
import store from './store'
import NProgress from 'nprogress'

const loginPath = '/account/login'
const defaultPath = '/index'
const whiteList = ['login']
NProgress.configure({ showSpinner: false })
router.beforeEach((to, from, next) => {
    NProgress.start()
    // เอกสารการตั้งค่าtitle
    // to.meta?.title && (document.title = to.meta.title)
    // console.log(store.getters.config.platform_name, 123456)

    const token = store.getters.token

    if (token) {
        if (to.path === loginPath) {
            next({ path: defaultPath })
        } else {
            next()
        }
    } else {
        if (whiteList.includes(to.name as string)) {
            // ในรายการไวท์ลิสต์ที่ไม่ต้องเข้าสู่ระบบ，เข้าโดยตรง
            next()
        } else {
            next({ path: loginPath, query: { redirect: to.fullPath } })
        }
    }
})

router.afterEach(() => {
    NProgress.done()
})
